<template>
  <div id="search">
    <div class="box-title">
      <p>{{ $t("message.strid47") }}</p>
    </div>
    <div class="search-box">
      <input
        @input="checkValue"
        v-model="value"
        type="text"
        :placeholder="$t('message.strid27')"
        :class="['input', error ? 'error' : '']"
      />
      <div class="blank"></div>
      <input
        v-model="code"
        type="text"
        :placeholder="$t('message.strid28')"
        class="input code"
      />
      <Button v-if="!showTimer" type="send" :noWrap="true" @click="sendCode">{{
        $t("message.strid23")
      }}</Button>
      <Button v-else type="send" :noWrap="true" >{{ time }} S</Button>
    </div>
    <Button :type="value && code ? 'active' : 'default'" @click="inquire">{{
      $t("message.strid24")
    }}</Button>
  </div>
</template>

<script>
import Button from "@/components/Button";
import { sendVc, getHistory } from "@/proxy/index";
export default {
  components: {
    Button
  },
  data() {
    return {
      value: "",
      showTimer: false,
      code: "",
      time: 120,
      error: false
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.timer) {
      clearInterval(this.timer);
    }
    next();
  },
  methods: {
    checkValue() {
      if (this.value) {
        this.error = false;
      }
    },
    checkemail(value) {
      return /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/.test(
        value
      );
    },
    inquire() {
      if (!this.value || !this.checkemail(this.value)) {
        this.error = true;
        return false;
      }
      if (!this.code) {
        return false;
      }
      getHistory(this.code, this.value).then(res => {
        if (res.data.code == 0) {
          if (res.data.data.length == 0) {
            this.$store.dispatch("setHis", {});
            Cookies.set("his", {}, { expires: 1 / 48 });
          } else {
            this.$store.dispatch("setHis", res.data.data.reverse());
            Cookies.set("his", res.data.data.reverse(), { expires: 1 / 48 });
          }
          this.$router.replace({ name: "history" });
        } else if (res.data.code == -20008) {
          alert(
            "Invalid verification code! Please re-enter verification code!"
          );
        } else {
          alert(`Service Error (${res.data.code})`);
        }
      });
    },
    sendCode() {
      if (!this.value || !this.checkemail(this.value)) {
        this.error = true;
        return false;
      }
      this.showTimer = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          this.time = 120;
          this.showTimer = false;
          clearInterval(this.timer);
        }
      }, 1000);
      sendVc(2, this.value).then(res => {
        if (res.data.code == 0) {
          alert(this.$t('message.strid71', { emails: this.value||'' }));
        } else {
          alert(`Service Error (${res.data.code})`);
        }
      });
    }
  }
};
</script>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/views/search.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/views/m/search.scss";
}
</style>
